<span class="status-badge status-badge--{{type}}">
    {{name}}
</span>
